<template>
  <div>
    <!-- Botão de Login do Facebook -->
    <button
      style="background-color: #1877f2; border: 0; border-radius: 4px; color: #fff; cursor: pointer; font-family: Helvetica, Arial, sans-serif; font-size: 16px; font-weight: bold; height: 40px; padding: 0 24px;"
      @click="launchWhatsAppSignup"
    >
      Entrar com Facebook
    </button>

  </div>
</template>

<script>
import { editInfosMetaAccount } from '../../../functions/basics/bot'

export default {
  data() {
    return {
      sessionInfoResponse: '',
      sdkResponse: '',
      phone_number_id: null,
      waba_id: null,
      business_id: null,
    }
  },
  mounted() {
    this.loadFacebookSDK()
    // Escutar mensagens da janela do popup
    window.addEventListener('message', event => {
      if (event.origin !== 'https://www.facebook.com' && event.origin !== 'https://web.facebook.com') {
        return
      }

      console.log('event 2: ', event)
      try {
        const data = JSON.parse(event.data)
        if (data.type === 'WA_EMBEDDED_SIGNUP') {
          // if user finishes the Embedded Signup flow
          if (data.event === 'FINISH') {
            const { phone_number_id, waba_id, business_id } = data.data
            this.phone_number_id = phone_number_id
            this.waba_id = waba_id
            this.business_id = business_id
            console.log('Phone number ID ', phone_number_id, ' WhatsApp business account ID ', waba_id, 'business_id: ', business_id)
            // if user cancels the Embedded Signup flow
          } else if (data.event === 'CANCEL') {
            const { current_step } = data.data
            console.warn('Cancel at ', current_step)
            // if user reports an error during the Embedded Signup flow
          } else if (data.event === 'ERROR') {
            const { error_message } = data.data
            console.error('error ', error_message)
          }
        }
      } catch {
        console.log('Non JSON Responses', event.data)
      }
    })
  },
  methods: {
    // Carregar o SDK do Facebook
    loadFacebookSDK() {
      // Evitar carregar o SDK mais de uma vez
      if (window.FB) {
        return
      }

      window.fbAsyncInit = () => {
        window.FB.init({
          appId: '2314475065582801', // Substitua pelo seu App ID do Facebook
          autoLogAppEvents: true,
          xfbml: true,
          version: 'v22.0',
        })
      };

      // Carregar o SDK do Facebook
      (function (d, s, id) {
        const fjs = d.getElementsByTagName(s)[0]
        if (d.getElementById(id)) return

        const js = d.createElement(s)
        js.id = id
        js.src = 'https://connect.facebook.net/en_US/sdk.js'
        fjs.parentNode.insertBefore(js, fjs)
      }(document, 'script', 'facebook-jssdk'))
    },

    // Função para lançar o processo de login via Facebook
    launchWhatsAppSignup() {
      window.FB.login(this.fbLoginCallback, {
        config_id: '656181160655967', // Substitua com o ID da configuração
        response_type: 'code',
        override_default_response_type: true,
        extras: {
          setup: {},
          featureType: '',
          sessionInfoVersion: '2',
        },
      })
    },

    // Callback após o login do Facebook
    fbLoginCallback(response) {
      if (response.authResponse) {
        const { code } = response.authResponse
        // Envie o código para o backend e faça a chamada server-to-server
        editInfosMetaAccount(this.$route.params.botId, code, this.phone_number_id, this.waba_id, this.business_id)
        console.log('code: ', code, this.phone_number_id, this.waba_id)
      }

      // Exibe a resposta do SDK
      this.sdkResponse = JSON.stringify(response, null, 2)
      console.log('sdkResponse', this.sdkResponse)
    },
  },

}
</script>

  <style scoped>
  /* Estilos personalizados podem ser adicionados aqui */
  </style>
